<template>
  <el-container class="widget-container">
    <!-- left aside -->
    <el-aside class="widget-aside widget-aside-left">
      <div class="widget-components">
        <div v-for="(field, index) in models" :key="index">
          <div class="widget-components-title">{{ field.title }}</div>
          <draggable tag="ul" :list="field.list" :group="{ name: 'form', pull: 'clone', put: false }"
            ghost-class="ghost" animation="1000" :sort="false">
            <template v-for="(item, index) in field.list">
              <li class="widget-components-label" :key="index">
                <span>
                  <i class="xa-icon icon" :class="item.icon"></i>
                  <em>{{ item.title || item.label }}</em>
                </span>
              </li>
            </template>
          </draggable>
        </div>
      </div>
    </el-aside>

    <!-- center container -->
    <el-container class="widget-main" direction="vertical">
      <el-header class="widget-header">
        <el-button type="text" size="medium" icon="el-icon-upload2" @click="onImportJson">导入JSON</el-button>
        <el-button type="text" size="medium" icon="el-icon-download" @click="onGenerateJson">生成JSON</el-button>
        <el-button type="text" size="medium" icon="el-icon-view" @click="onPreview">预览</el-button>
        <el-button type="text" size="medium" icon="el-icon-refresh-left" :disabled="!records.isUndo"
          @click="onUndo">撤销</el-button>
        <el-button type="text" size="medium" icon="el-icon-refresh-right" :disabled="!records.isRedo"
          @click="onRedo">重做</el-button>
        <el-button type="text" size="medium" icon="el-icon-check" :loading="saveLoading" @click="onSave">保存</el-button>
        <el-button v-if="microOpen!=='true'" type="text" size="medium" icon="el-icon-close"
          @click="onCancel">取消</el-button>
      </el-header>
      <widget-canvas :data="data" :select.sync="widgetsSelect" @change="onWidgetsChange(data.list)"></widget-canvas>
    </el-container>

    <!-- right config -->
    <el-aside class="widget-aside widget-aside-right" width="360px">
      <el-tabs v-model="configTab" stretch>
        <el-tab-pane label="组件属性" name="widget" style="padding: 0 10px">
          <widget-config :data="widgetsSelect" />
        </el-tab-pane>
        <el-tab-pane label="报表设置" name="form" lazy style="padding: 0 10px">
          <widget-report :data="data"></widget-report>
        </el-tab-pane>
      </el-tabs>
    </el-aside>

    <!-- 导入JSON-->
    <el-drawer title="导入JSON" :visible.sync="drawer.showImportJson" size="30%" append-to-body destroy-on-close
      class="widget-drawer">
      <vue-json-editor :value.sync="importJson" :showBtns="true" mode="code" lang="zh" @json-save="onImportJsonSave" />
    </el-drawer>

    <!-- 生成JSON-->
    <el-drawer title="生成JSON" :visible.sync="drawer.showGenerateJson" size="30%" append-to-body destroy-on-close>
      <vue-json-editor :value.sync="generateJson" :showBtns="false" :editable="false" mode="code" lang="zh" />
    </el-drawer>

    <!-- 预览 -->
    <el-drawer title="预览" :visible.sync="drawer.showPreview" size="60%" append-to-body>
      <widget-preview :data="previewJson" />
    </el-drawer>
  </el-container>
</template>
<script>
import draggable from 'vuedraggable'
/** 引入功能组件、属性组件*/
import '@/dragComponents/index.js'
import '@/dragComponents/config/index.js'

import reportField from '@/dragComponents/model'
import HistoryRecord from '@/dragComponents/utils/historyRecord'
import {
  deepClone,
  isEmpty,
  setTempField,
  deleteTempField,
  getModelsByCategory,
  getQueryArrByParams
} from '@/dragComponents/utils'
import main from '@/dragComponents/mixins/main.js'
import vueJsonEditor from '@/dragComponents/components/vueJsonEditor'
import widgetCanvas from './fragment/widgetCanvas.vue'
import widgetConfig from './fragment/widgetConfig.vue'
import widgetReport from './fragment/widgetReport.vue'
import widgetPreview from './fragment/widgetPreview.vue'

export default {
  name: 'data-report-design',
  mixins: [main],
  components: {
    draggable,
    vueJsonEditor,
    widgetCanvas,
    widgetConfig,
    widgetReport,
    widgetPreview
  },
  provide() {
    return {
      category: 'report',
      device: 'desktop',
      outerParams: []
    }
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      microOpen: 'false',
      appId: '',
      records: null,
      data: {
        id: '',
        reportName: '',
        reportKey: '',
        type: 'report',
        list: [],
        redirect: '',
        authType: '',
        roleList: []
      },
      widgetsSelect: {},
      configTab: 'widget',
      drawer: {
        showImportJson: false,
        showGenerateJson: false,
        showPreview: false
      },
      importJson: {},
      generateJson: {},
      previewJson: {}
    }
  },
  computed: {
    models() {
      return getModelsByCategory(deepClone(reportField), 'report')
    }
  },
  watch: {
    widgetsSelect: {
      handler(val) {
        this.records.push(this.data, 'update')
        // console.log('update data==', this.records)
      },
      deep: true
    }
  },
  methods: {
    loadData() {
      let id = this.$route.query.id ? this.$route.query.id : null
      this.appId = this.$route.query.appId || ''
      this.microOpen = this.$route.query.microOpen || 'false'
      // 获取外部参数
      this.outerParams = getQueryArrByParams(this.$route.query)
      if (isEmpty(id)) {
        this.records.init(this.data)
        return
      }
      this.loading = true
      this.$http
        .get(`/data-report/model/${id}`)
        .then((res) => {
          if (res.code === 200) {
            const modelJsonMap = res.data.modelJsonMap
            if (modelJsonMap && modelJsonMap.list) {
              modelJsonMap.list = setTempField(modelJsonMap.list)
              // 绑定上id
              modelJsonMap.id = !isEmpty(modelJsonMap.id) ? modelJsonMap.id : id
              let data = { ...this.data, ...modelJsonMap }
              this.data = this.records.init(data)
              this.widgetsSelect = this.data.list[0] || {}
            }
            this.loading = false
          }
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.msg)
        })
    },
    formatData() {
      let json = deepClone(this.data)
      json.list = deleteTempField(json.list)
      return json
    },
    onWidgetsChange(widgets) {
      this.data.list = widgets
    },
    onImportJson() {
      this.drawer.showImportJson = true
    },
    onImportJsonSave(importJson) {
      if (importJson && importJson.list) {
        importJson.list = setTempField(importJson.list)
        this.data = importJson
        this.widgetsSelect = this.data.list[0] || {}
      }
      this.drawer.showImportJson = false
    },
    onGenerateJson() {
      this.generateJson = this.formatData()
      this.drawer.showGenerateJson = true
    },
    onPreview() {
      this.previewJson = deepClone(this.data)
      this.drawer.showPreview = true
    },
    onUndo() {
      this.data = this.records.undo()
      this.widgetsSelect = {}
      // console.log('undo==', this.records)
    },
    onRedo() {
      this.data = this.records.redo()
      this.widgetsSelect = {}
      // console.log('redo==', this.records)
    },
    onSave() {
      if (!this.data.reportName) {
        return this.$message.error('报表名称不能为空！')
      }
      if (!this.data.reportKey) {
        return this.$message.error('报表关键字不能为空！')
      }
      // if (this.data.list.length == 0)
      //   return this.$message.error("您还没有设计报表！");
      // 数据处理并进行保存
      this.data = this.formatData()
      this.data.type = 'report'
      this.data.appId = this.appId
      this.saveLoading = true

      this.$http
        .post('/data-report/model', this.data)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            // this.$router.push('/reportModel/index')
          }
        })
        .catch((err) => {
          this.$message.error(err.msg)
        })
        .finally(() => {
          this.saveLoading = false
        })
    },
    onCancel() {
      this.$confirm(
        '之前的操作尚未保存, 取消后数据将会丢失，是否继续?',
        '确认取消',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$router.push('/reportModel/index')
        })
        .catch(() => { })
    }
  },
  created() {
    this.records = new HistoryRecord()
    this.loadData()
    this.loadApitableList()
  },
  mounted() {
    this.$nextTick(() => {
      let avueContail = document.querySelector('.avue-contail')
      let avueLayout = document.querySelector('.avue-layout')
      let avueMain = document.querySelector('.avue-main')
      if (avueContail) {
        avueContail.style.height = '100%'
        avueContail.style.overflow = 'hidden'
      }
      if (avueLayout) avueLayout.style.height = '100%'
      if (avueMain) avueMain.style.height = '100%'
    })
  },
  destroyed() {
    let avueContail = document.querySelector('.avue-contail')
    let avueLayout = document.querySelector('.avue-layout')
    let avueMain = document.querySelector('.avue-main')
    if (avueContail) avueContail.style.overflow = 'inherit'
    if (avueLayout) avueLayout.style.height = 'inherit'
    if (avueMain) avueMain.style.height = 'inherit'
  }
}
</script>
<style lang='scss'>
@import "../styles/index.scss";
</style>
<style lang="scss" scoped>
.widget {
  &-container {
    overflow: hidden;
    height: 85%;
    background: #fff;
  }

  &-aside {
    &-right {
      :deep(.el-tabs) {
        height: 100%;
      }

      :deep(.el-tabs__header) {
        margin: 0;
        height: 60px;
        line-height: 60px;
        background: #fff;
        z-index: 1000;
      }

      :deep(.el-tabs__content) {
        height: calc(100% - 60px);
        overflow-y: scroll;
      }

      :deep(.el-tabs__item) {
        height: 60px;
        line-height: 60px;
      }
    }
  }
}
</style>
